import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ContentNegotiationInterceptor } from './interceptors/content-negotiation-interceptor';
import { AcceptLanguageInterceptor } from './interceptors/accept-language-interceptor';

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ContentNegotiationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AcceptLanguageInterceptor,
      multi: true,
    },
  ],
})
export class GlobalSharedModule {}
